import React from 'react';
import TestimonialCard from './TestimonialCard';

interface Testimonial {
  name: string;
  relationship: string;
  image: string;
  alt: string;
  quote: string;
  yearsMarried?: number;
}

const WisdomSection = () => {
  const testimonials: Testimonial[] = [
  {
    name: "Apostle Grace Lubega",
    relationship: "Church Elders",
    image: "/assets/images/15-1783667573404.jpeg",
    alt: "Elderly African couple in formal church attire smiling warmly at camera",
    quote: "We have watched Moyak and Gloria grow in their faith and love for each other. Their commitment to honoring God first and respecting our cultural traditions is a beautiful testimony. May their marriage be a light to others.",
    yearsMarried: 42
  },
  {
    name: "Uncle Peter & Aunt Grace Makuei",
    relationship: "Family Elders",
    image: "/assets/images/9-1783667599408.jpeg",
    alt: "Middle-aged African couple in traditional South Sudanese attire standing together outdoors",
    quote: "In our culture, marriage is not just between two people but between two families. Moyak and Gloria understand this deeply. They have sought wisdom, honored the dowry tradition, and brought our families together in unity. This is how marriages should begin.",
    yearsMarried: 35
  },
  {
    name: "Dr. Samuel & Rebecca Garang",
    relationship: "Mentors",
    image: "/assets/images/1-1783667533431.jpeg",
    alt: "Professional African couple in business attire smiling confidently in modern office setting",
    quote: "The foundation they are building—rooted in faith, communication, and mutual respect—will sustain them through all seasons. We are honored to walk alongside them as they begin this sacred journey.",
    yearsMarried: 28
  }];


  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-surface">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-playfair text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Wisdom from Our Elders
          </h2>
          <p className="font-inter text-lg text-muted-foreground max-w-2xl mx-auto">
            Blessed by the counsel and prayers of those who have walked this path before us
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) =>
          <TestimonialCard
            key={index}
            name={testimonial.name}
            relationship={testimonial.relationship}
            image={testimonial.image}
            alt={testimonial.alt}
            quote={testimonial.quote}
            yearsMarried={testimonial.yearsMarried} />

          )}
        </div>
      </div>
    </section>);

};

export default WisdomSection;